import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FiArrowLeft, FiUser, FiMail, FiPhone, FiLock, FiBookOpen } from "react-icons/fi";
import { VscEyeClosed } from "react-icons/vsc";
import { RxEyeOpen } from "react-icons/rx";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import axios from "axios";
import apiKey from "../config/apiKey";
import { toast } from "react-toastify";
import logo from "../assets/new images/logo.png";

const FormSignUp = (props) => {
  const [isLoading, setIsLoading] = useState(false);    // unchanged behavior
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    type: "online",
    password: "",
    password_confirmation: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    axios
      .post(`${apiKey}/api/edolutions/teacher/register`, formData)
      .then(() => {
        toast.success("Verification email sent. Please check your inbox.", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: { backgroundColor: "#2A3A54", color: "#fff" },
        });
        navigate("/login/mentor-login");
      })
      .catch((err) => {
        if (err?.response?.data?.data) setErrors(err.response.data.data);
        else setErrors({ general: "An unexpected error occurred" });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="relative min-h-screen w-full grid place-items-center overflow-hidden">
      {/* Soft peach background like screenshot */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FFF4EE] via-[#FFF8F4] to-white" />
      <div className="pointer-events-none absolute -left-24 -top-24 w-[38rem] h-[38rem] rounded-full bg-[#FFB899]/25 blur-3xl" />
      <div className="pointer-events-none absolute -right-28 bottom-0 w-[42rem] h-[42rem] rounded-full bg-[#FFD9C9]/30 blur-3xl" />

      <div className="relative w-full max-w-2xl px-5">
        {/* Back to Home */}
        <div className="mb-2">
          <NavLink
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#6B7280] hover:text-[#111827]"
          >
            <FiArrowLeft className="h-4 w-4" />
            Back to Home
          </NavLink>
        </div>

        {/* Card */}
        <div className="mx-auto mb-5 rounded-3xl border border-[#F7C9B7] bg-white/90 shadow-[0_10px_40px_-15px_rgba(17,24,39,0.15)] px-6 py-8 md:px-10 md:py-10">
          {/* Logo pill */}
          <div className="mx-auto -mt-3 mb-5 w-16 h-16 grid place-items-center rounded-2xl bg-white shadow-xl shadow-orange-600/30">
            <img src={logo} alt="logo" className="w-10 h-10 object-contain" />
          </div>

          {/* Heading */}
          <div className="text-center">
            <h1 className="text-3xl md:text-[32px] font-extrabold">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]">
                Welcome Back!
              </span>
            </h1>
            <p className="mt-2 text-sm text-[#6B7280]">
              Share your expertise and make a lasting impact <br/> on aspiring professionals
            </p>
          </div>

          {/* Form (fields & functionality unchanged) */}
          <form onSubmit={handleSubmit} className="mt-8 space-y-5">
            {errors.general && (
              <div className="rounded-md bg-red-50 text-red-700 text-sm px-3 py-2">
                {errors.general}
              </div>
            )}

            {/* Full Name */}
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-2">
                Full Name
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 grid place-items-center">
                  <FiUser className="h-4 w-4 text-[#9CA3AF]" />
                </span>
                <input
                  className="w-full rounded-xl border border-[#E5E7EB] bg-white pl-10 pr-3 py-3 text-[15px] outline-none focus:border-[#EE5F2B] focus:ring-2 focus:ring-[#EE5F2B]/20 transition"
                  type="text"
                  placeholder="Enter your full name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              {errors.name && <p className="text-xs text-red-600 mt-1">{errors.name[0]}</p>}
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-2">
                Email Address
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 grid place-items-center">
                  <FiMail className="h-4 w-4 text-[#9CA3AF]" />
                </span>
                <input
                  className="w-full rounded-xl border border-[#E5E7EB] bg-white pl-10 pr-3 py-3 text-[15px] outline-none focus:border-[#EE5F2B] focus:ring-2 focus:ring-[#EE5F2B]/20 transition"
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              {errors.email && <p className="text-xs text-red-600 mt-1">{errors.email[0]}</p>}
            </div>

            {/* Phone */}
         {/* Phone */}
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-2">
                Phone Number
              </label>
              <div className="relative rounded-xl border border-[#E5E7EB] bg-white pl-10 pr-3 py-[6px]">
                <span className="absolute inset-y-0 left-3 grid place-items-center">
                  <FiPhone className="h-4 w-4 text-[#9CA3AF]" />
                </span>

                <PhoneInput
                  country={"pk"}
                  // ✅ Only Middle East countries (as requested)
                  onlyCountries={["ae", "pk", "om", "qa", "sa"]}
                  // optional: show these on top of the list (kept same order as onlyCountries)
                  preferredCountries={["pk", "sa", "ae", "qa", "om"]}
                  value={formData.phone}
                  onChange={(v) => setFormData({ ...formData, phone: v })}
                  inputProps={{ name: "phone", required: true }}
                  // keep your styling
                  inputStyle={{
                    width: "100%",
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    fontSize: "15px",
                    paddingLeft: "48px", // keeps room for the left icon
                  }}
                  buttonStyle={{ border: "none", background: "transparent" }}
                  containerStyle={{ width: "100%" }}
                />
              </div>
              {errors.phone && (
                <p className="text-xs text-red-600 mt-1">{errors.phone[0]}</p>
              )}
            </div>

            {/* Teaching Type */}
            {/* <div>
              <label className="block text-sm font-medium text-[#111827] mb-2">
                Area of Expertise
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 grid place-items-center">
                  <FiBookOpen className="h-4 w-4 text-[#9CA3AF]" />
                </span>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="w-full appearance-none rounded-xl border border-[#E5E7EB] bg-white pl-10 pr-8 py-3 text-[15px] outline-none focus:border-[#EE5F2B] focus:ring-2 focus:ring-[#EE5F2B]/20 transition"
                >
                  <option value="">Select</option>
                  <option value="home">Home Tutoring</option>
                  <option value="online">Online Tutoring</option>
                  <option value="both">Both</option>
                </select>
              </div>
              {errors.type && (
                <p className="text-xs text-red-600 mt-1">Teaching Type is Required</p>
              )}
            </div> */}

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-2">
                Password
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 grid place-items-center">
                  <FiLock className="h-4 w-4 text-[#9CA3AF]" />
                </span>
                <input
                  className="w-full rounded-xl border border-[#E5E7EB] bg-white pl-10 pr-11 py-3 text-[15px] outline-none focus:border-[#EE5F2B] focus:ring-2 focus:ring-[#EE5F2B]/20 transition"
                  type={showPassword ? "text" : "password"}
                  placeholder="Type your password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-2 px-2 grid place-items-center text-[#6B7280] hover:text-[#111827]"
                  onClick={() => setShowPassword((s) => !s)}
                >
                  {showPassword ? <RxEyeOpen className="h-5 w-5" /> : <VscEyeClosed className="h-5 w-5" />}
                </button>
              </div>
              {errors.password && <p className="text-xs text-red-600 mt-1">{errors.password[0]}</p>}
            </div>

            {/* Confirm Password */}
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-2">
                Confirm Password
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 grid place-items-center">
                  <FiLock className="h-4 w-4 text-[#9CA3AF]" />
                </span>
                <input
                  className="w-full rounded-xl border border-[#E5E7EB] bg-white pl-10 pr-11 py-3 text-[15px] outline-none focus:border-[#EE5F2B] focus:ring-2 focus:ring-[#EE5F2B]/20 transition"
                  type={showPassword2 ? "text" : "password"}
                  placeholder="Type your password"
                  name="password_confirmation"
                  value={formData.password_confirmation}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-2 px-2 grid place-items-center text-[#6B7280] hover:text-[#111827]"
                  onClick={() => setShowPassword2((s) => !s)}
                >
                  {showPassword2 ? <RxEyeOpen className="h-5 w-5" /> : <VscEyeClosed className="h-5 w-5" />}
                </button>
              </div>
              {errors.password_confirmation && (
                <p className="text-xs text-red-600 mt-1">{errors.password_confirmation[0]}</p>
              )}
            </div>

            {/* Submit — your theme gradient */}
            <button
              className={`w-full rounded-xl py-3.5 text-white font-semibold shadow-sm transition
                ${isLoading ? "opacity-60 cursor-not-allowed" : "hover:shadow-md"}
                bg-[#EE5F2B]`}
              disabled={isLoading}
            >
              {isLoading ? "Signing Up…" : "Sign Up"}
            </button>

            <div className="h-[1px] w-[95%] bg-gray-200 mx-auto"></div>

            <p className="text-center text-sm text-[#6B7280]">
              Already have an account?{" "}
              <Link to={props.path || "/login/mentor-login"} className="text-[#EE5F2B] font-semibold hover:underline">
                Sign in
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FormSignUp;
